import {createButton} from "./common/ui";

export default class UiSettings extends PIXI.Container
{
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const config = configGame.Settings;
        const screen = configGame.Screen;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");
        this.sndDeckClick = sounds.get("res/sounds/deck_click");

        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "background_utility.png"]);
        this.background.position = config.background.pos;
        this.background.interactive = true;     // block interactive of overlaid buttons
        this.addChild(this.background);

        this.selectDeck = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "title_select_deck.png"]);
        this.selectDeck.position = config.selectDeck.pos;
        this.background.addChild(this.selectDeck);

        this.titleClassic = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "classic.png"]);
        this.titleClassic.position = config.titleClassic.pos;
        this.background.addChild(this.titleClassic);

        this.titlePinup = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "pin_up.png"]);
        this.titlePinup.position = config.titlePinup.pos;
        this.background.addChild(this.titlePinup);

        this.buttonOk = createButton(this.background, config.buttonOk.pos.x, config.buttonOk.pos.y, packFolder + "ok", this.sndBtnClick);

        let arrDeckInfo = [
            {x: config.arrDeckInfo[0].x, y: config.arrDeckInfo[0].y, folder: packFolder + "deck_0"},
            {x: config.arrDeckInfo[1].x, y: config.arrDeckInfo[1].y, folder: packFolder + "deck_1"}
        ];
        this.arrBackDeck = [];
        this.buttonsRadioDeck = [];
        for (let obj of arrDeckInfo) {
            let back = new PIXI.Sprite(PIXI.utils.TextureCache[obj.folder + "/back.png"]);
            back.position.set(obj.x, obj.y);
            this.addChild(back);
            this.arrBackDeck.push(back);

            let button = createButton(this, obj.x, obj.y, obj.folder);
            button.texDown = PIXI.utils.TextureCache[obj.folder + "/down.png"];
            button.texOver = PIXI.utils.TextureCache[obj.folder + "/over.png"];

            // .off(event, fn) clear all listeners or concrete
            button.off('pointerover'); button.off('pointerdown'); button.off('pointerup');
            button.off('pointerover'); button.off('pointerout'); button.off('pointerupoutside');

            button.on('pointerup',function() {
                self._onPointerUpRadioButton(button);
            });
            this.buttonsRadioDeck.push(button);
        }

        this.deckInd = 0;
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.layerBlockInput = null;

        this.background = null;
        this.selectDeck = null;
        this.titlePinup = null;
        this.titleClassic = null;
        this.buttonOk = null;

        for (let obj of this.arrBackDeck) obj = null;
        this.arrBackDeck = null;

        for (let obj of this.buttonsRadioDeck) obj = null;
        this.buttonsRadioDeck = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
        this.sndDeckClick.stop();
        this.sndDeckClick = null;
    }

    setActiveDeck (ind) {
        this._onPointerUpRadioButton(this.buttonsRadioDeck[ind], false);
        this.deckInd = ind;
    }

    resetActiveDeck () {
        this._onPointerUpRadioButton(this.buttonsRadioDeck[this.deckInd], false);
    }

    setOnButtonApplyEvent (func) {
        let self = this;
        this.buttonOk.callback = function() {
            self.deckInd = self.buttonsRadioDeck[0].texture === self.buttonsRadioDeck[0].texOver ? 0 : 1;
            func(self.deckInd);
        };
    }

    _onPointerUpRadioButton (button, isSoundOn = true) {
        for (let radioButton of this.buttonsRadioDeck) {
            radioButton.texture = radioButton.texDown;
        }
        button.texture = button.texOver;

        if (isSoundOn)
            this.sndDeckClick.play()
    }
}


// WEBPACK FOOTER //
// ./src/uisettings.es6